import React, { useState, useContext } from "react";
import { AuthContext } from "../../context/authContext";
import { decryptPrivateKeyWithPassword } from "../../utils/cryptoUtils"; 
import "./unlockModal.scss"; 

const UnlockModal = () => {
    const { currentUser, setPrivateKey, logout } = useContext(AuthContext);
    const [pin, setPin] = useState("");
    const [error, setError] = useState("");
    const [isUnlocking, setIsUnlocking] = useState(false);

    const handleUnlock = async (e) => {
        e.preventDefault();
        setError("");
        setIsUnlocking(true);

        try {
            if (!currentUser?.encryptedPrivateKey) {
                throw new Error("Không tìm thấy khóa mã hóa bảo mật của tài khoản này!");
            }

            const decrypted = await decryptPrivateKeyWithPassword(
                currentUser.encryptedPrivateKey, 
                pin
            );
            
            setPrivateKey(decrypted); 
        } catch (err) {
            setError("Mã PIN không đúng. Vui lòng thử lại!");
        } finally {
            setIsUnlocking(false);
        }
    };

    return (
        <div className="unlockModal">
            <div className="unlock-modal-box">
                <h2>
                    🔒 Mở khóa E2EE
                </h2>

                <p>
                    Phiên bản mã hóa đã bị khóa (do tải lại trang hoặc đăng nhập Web3). Vui lòng nhập mã PIN bảo mật để tiếp tục.
                </p>
                
                <form onSubmit={handleUnlock}>
                    <input 
                        type="password" 
                        placeholder="Nhập mã PIN / Mật khẩu..." 
                        value={pin}
                        onChange={(e) => setPin(e.target.value)}
                        required
                        autoFocus
                    />

                    {error && 
                        <span className="error-message">
                            {error}
                        </span>
                    }
                    
                    <div className="button-group">
                        <button type="submit" className="btn-unlock" disabled={isUnlocking}>
                            {isUnlocking ? "Đang mở khóa..." : "Mở khóa"}
                        </button>

                        <button type="button" className="btn-logout" onClick={logout}>
                            Đăng xuất
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UnlockModal;